module.exports = __webpack_public_path__ + "img/COM-B-1-II.4e819366.png";